var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.data.icon && _vm.$style.icon,
    _vm.data.icon && _vm.$style[("icon_" + (_vm.data.icon))] ]},[(_vm.data.type === 'qrc')?_c('div',{class:_vm.$style.qrc},[_c('img',{attrs:{"src":_vm.qrc}})]):_vm._e(),_vm._v(" "),(_vm.data.type !== 'qrc')?_c('div',{class:[_vm.$style.title]},[_vm._v("\n    "+_vm._s(_vm.data.title)+"\n    "),_c('span',[_vm._v(">")])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.$style.desc,domProps:{"innerHTML":_vm._s(
      _vm.data.type === 'contact'
        ? ((_vm.contact.phone_cs ? ("客服专线：" + (_vm.contact.phone_cs) + "<br />") : '') + "公司电话：" + (_vm.contact.phone || ''))
        : _vm.data.desc
    )}})])}
var staticRenderFns = []

export { render, staticRenderFns }